export const hero = {
  title: 'Kia Tjänstebil',
  subtitle:
    'Bli en del av den laddbara friheten med en tjänstebil från Kia. Innovativ teknik och generösa utrustningsnivåer som standard.',
  image: 'https://kia-afonso-storage.b-cdn.net/EV5_Friheten-Vantar_2.jpg',
  mobileImage: 'https://kia-afonso-storage.b-cdn.net/EV5_Friheten-Vantar_2.jpg',
};

export const companyOffer = {
  image:
    'https://kia-afonso-storage.b-cdn.net/Kia-Range_7bilar_Business_Edition.jpg',
  title: 'Kia Business Edition.',
  subTitle: 'Fullutrustade bilar, attraktiva förmånsvärden.',
  text: 'Med Business Edition får du våra populära elbilar Kia EV3, EV4, EV5, EV6 och EV9 i fullutrustade GT Line-utföranden, med attraktiva förmånsvärden. Dessutom finns nu Kia Sportage Plug-In Hybrid och Kia Sorento Plug-In Hybrid som Business Edition. Upptäck den laddbara friheten.',
  link: 'https://www.kia.com/se/tjanstebil/business-edition/',
  linkText: 'Läs om Business Edition',
};

export const collage = {
  title: 'Den laddbara friheten',
  text: 'Med en Kia som tjänstebil får du innovativ teknik, hög komfort och de senaste säkerhets- och infotainment-systemen med uppkopplade tjänster – samt flexibla finansieringslösningar. Vill du dessutom köra en tjänstebil med fyrhjulsdrift finns det flera laddbara modeller att välja bland. Laddbar frihet när den är som bäst.',
  images: [
    {
      src: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/logo.jpg',
      alt: 'Kia logo',
    },
    {
      src: 'https://kia-afonso-storage.b-cdn.net/EV9-2024.jpg',
      alt: 'Livet med fyrhjulsdrift',
      title: 'Livet med fyrhjulsdrift',
      text: 'Kia EV9, Kia EV6, Kia Sportage Plug-In Hybrid och Kia Sorento Plug-In Hybrid är fyra populära tjänstebilar med fyrhjulsdrift. Alla med generösa utrymmen och fulla av innovativ teknik. ',
    },
    {
      src: 'https://kia-afonso-storage.b-cdn.net/Ev6-FL-2024-Dec.jpg',
      alt: 'Ultrasnabb laddning',
      title: 'Ultrasnabb laddning',
      text: 'Kia EV6 och Kia EV9 har båda 800-voltsteknik som möjliggör laddning av batteriet från 10-80% på ned till 18 respektive 24 minuter med en >250 kW snabbladdare.',
    },
  ],
};

export const collage2 = {
  title: 'Den laddbara friheten',
  text: 'Med en Kia som tjänstebil får du innovativ teknik, hög komfort och de senaste säkerhets- och infotainment-systemen med uppkopplade tjänster – samt flexibla finansieringslösningar. Vill du dessutom köra en tjänstebil med fyrhjulsdrift finns det flera laddbara modeller att välja bland. Laddbar frihet när den är som bäst.',
  images: [
    {
      src: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/Kia-Tjanstebil-1.jpg',
      alt: 'Kia logo',
    },
    {
      src: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/Kia-Tjanstebil-2.jpg',
      alt: 'Tjänstebilen som powerbank?',
      title: 'Tjänstebilen som powerbank?',
      text: 'Våra elbilar har funktionen Vehicle-to-Load (V2L) som innebär att du kan använda din elbil för att driva eller ladda till exempel en kaffekokare, elcykel eller annan utrustning du har med dig på resan.',
      link: 'https://www.kia.com/se/om-kia/upplev-kia/teknik/',
    },
    {
      src: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/Kia-Tjanstebil-3.jpg',
      alt: 'Plug & Charge',
      title: 'Plug & Charge',
      text: 'Med Plug & Charge blir laddstoppen otroligt smidiga. Laddning och betalning startar automatiskt när du ansluter kabeln. Det innebär att du behöver varken app eller betalkort när du ska ladda.',
      link: 'https://kiacharge.com/web/sv/kia-se/service',
    },
  ],
};

export const table = {
  businessTitle: 'Kia Business Lease',
  businessText:
    'Kia Business Lease är en paketlösning där finansiering, försäkring, service och vinterdäck ingår. Allt samlat på en månadsfaktura. Du behöver inte bekymra dig över restvärdet, det är garanterat, och första förhöjd hyra är valfritt.',
  financialTitle: 'Kia Finansiell Leasing',
  financialText:
    'Med Kia Finansiell Leasing väljer du själv till de tjänster du behöver samt sätter bilens restvärde. Kia Finans hyr ut bilen mot en månadskostnad. Leasingavgiften bestäms av bilens nettopris, kapitalkostnaden och fordonets restvärde.',
  rows: [
    {
      title: 'Garanterat restvärde',
      business: 'Ja',
      financial: 'Nej',
    },
    {
      title: 'Kia serviceavtal',
      business: 'Ingår',
      financial: 'Tillval',
    },
    {
      title: 'Kia bilförsäkring',
      business: 'Ingår',
      financial: 'Tillval',
    },
    {
      title: 'Kia Original Vinterhjul',
      business: 'Ingår',
      financial: 'Tillval',
    },
  ],
};

export const imageAndLink = {
  image:
    'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/KiaSorento.jpg',
  text: 'Vi hjälper dig att hitta den finansieringslösning som passar bäst - på länken nedan hittar du mer information om våra olika modeller och finansieringslösningar.',
  link: 'https://www.kia.com/se/tjanstebil/foretagsleasing/',
};

export const rentAndShareImageAndLink = {
  image:
    'https://kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/hyr-och-dela/Appsida-bild-man.jpg',
  title: 'Kia Drive, Hyr & Dela.',
  text: 'Med bildelningstjänsten Kia Drive, hyr ni bilar månadsvis och kan enkelt anpassa er flotta efter behov. Bilarna används som företagsbil i tjänsten men kan även hyras av medarbetare eller kunder. Allt som krävs är vår app Kia Drive.',
  link: 'https://www.kia.com/se/kopa/hyr-och-dela/',
};

export const driverNews = {
  title: 'Bra att veta för dig som kör tjänstebil',

  link_style: 'text',
  description:
    'Hur fungerar drivmedelsersättningen? Hur beräknas egentligen förmånsvärdet? Och vilka tjänstebilsmodeller kan du välja mellan? Här hittar du information om vanliga begrepp och frågor som rör tjänstebilsaffären - så att det blir ännu enklare för dig att välja en Kia som tjänstebil.',
  articles: [
    {
      title: 'Förmånsvärde',
      text: 'Om du som anställd har en tjänstebil som du använder privat, behöver du utgå ifrån att den förmånen ska förmånsbeskattas. Varje bilmodell förses med ett förmånsvärde baserat på dess pris och CO2-utsläpp, och som läggs ovanpå din bruttolön.',
      link: 'https://www.kia.com/se/tjanstebil/priser/',
    },
    {
      title: 'Vad är skillnaden mellan olika typer av tjänstebilar?',
      text: 'En förmånsbil är en tjänstebil som din arbetsgivare låter dig använda privat. Det klassas som en löneförmån som du betalar skatt för. En personalbil är en bil som hyrs genom arbetsgivaren och disponeras av medarbetaren som en privat bil. Medarbetaren betalar för hela kostnaden som arbetsgivaren har för bilen genom bruttolöneavdrag. En renodlad tjänstebil får endast användas i tjänsten och för denna betalar man inget förmånsvärde.',
    },
    {
      title: 'Bonus Malus',
      text: 'För att minska koldioxidutsläppen infördes 2018 skattesystemet Bonus Malus. Bilar med höga CO2-utsläpp bestraffas med malus-skatt, och fordon med låga C02-utsläpp premierades med en klimatbonus. Regeringen beslutade att avskaffa klimatbonusen den 8 november 2022.',
    },
    {
      title: 'Drivmedelsersättning',
      text: 'Drivmedelsersättning kan beräknas på två olika sätt, kallat huvudregeln och komplementregeln. Huvudregeln innebär att den anställde betalar bränslet själv och sedan tar ut milersättning för de tjänstemil som körs. Komplementregeln innebär att företaget står för hela bränslekostnaden och att föraren förmånsbeskattas för privatmilen. Läs mer om drivmedelsersättning under ”Vanliga frågor och svar om tjänstebilar”.',
    },
    {
      title: 'Vill du veta mer?',
      text: 'Är du ansvarig för ditt företags tjänstebilar och vill veta mer om Kias tjänstebilserbjudande? Då är du välkommen att kontakta din Kia-återförsäljare som hjälper dig med rådgivning.',
      link: 'https://www.kia.com/se/tjanstebil/kia-fleet-team/',
    },
    {
      title: 'Brett utbud av tjänstebilar',
      text: 'Vi vet vad som krävs av en tjänstebil och utvecklar hela tiden våra modeller så att de lever upp till våra högt ställda krav på innovation, kvalitet och design. Här kan du se hela vårt utbud av innovativa tjänstebilar med mycket körglädje.',
      link: 'https://www.kia.com/se/nya-bilar/bilmodeller/',
    },
  ],
};

export const companyNews = {
  title: 'Bra att veta för dig som erbjuder tjänstebil till dina anställda',

  image_src: 'https://www.fillmurray.com/840/450',
  link_style: 'text',
  description:
    'Vilka finansiella lösningar kan ditt företag använda sig av när det gäller tjänstebilar? Hur beräknas restvärdet? Och vilka tjänstebilsmodeller kan du välja mellan? Här hittar du information om vanliga begrepp och frågor som rör tjänstebilsaffären - så att det blir ännu enklare för dig att välja en Kia som tjänstebil.',
  articles: [
    {
      title: 'TCO',
      text: 'TCO står för Total Cost of Ownership. Det är den totala ägandekostnaden som avgör hur mycket en bil kommer att kosta i slutänden. För att räkna ut TCO ska alla kostnader inkluderas, som till exempel leasingavgift, extrautrustning, service, försäkringar, skatter osv. Du kan läsa mer om TCO under ”Vanliga frågor och svar om tjänstebilar.”',
    },
    {
      title: 'Finansiell och operationell leasing',
      text: 'Om du väljer finansiell leasing får du en flexibel lösning med många valmöjligheter. Kunden äger bilen och ansvarar för dess restvärde. Leasingavgiften bestäms av bilens nettopris, kapitalkostnaden och fordonets restvärde som sätts baserat på körprofil. Om övriga bilkostnader uppstår hanteras de av kunden. Vid operationell leasing ägs bilen av leasingbolaget som också ansvarar för restvärdet och bilen hyrs ut till kunden till en fast avgift där alla omkostnader är inkluderade.',
      link: 'https://www.kia.com/se/tjanstebil/inkopare-farre-an-50-bilar/finansiering/',
    },
    {
      title: 'Bilpolicy',
      text: 'Företag tar ofta fram en bilpolicy för att definiera regler kring inköp och användning av tjänste- och förmånsbilar. Behöver du som inköpare råd och hjälp kring utformandet av en bilpolicy kan en Certifierad Företagsrådgivare hos en Kia- återförsäljare hjälpa till. Läs mer under ”Vanliga frågor och svar om tjänstebilar.”',
    },
    {
      title: 'Vill du veta mer?',
      text: 'Är du ansvarig för ditt företags tjänstebilar och vill veta mer om Kias tjänstebilserbjudande? Då är du välkommen att kontakta din Kia-återförsäljare som hjälper dig med rådgivning.',
      link: ' https://www.kia.com/se/tjanstebil/kia-fleet-team/',
    },
    {
      title: 'Brett utbud av tjänstebilar',
      text: 'Vi vet vad som krävs av en tjänstebil och utvecklar hela tiden våra modeller så att de lever upp till våra högt ställda krav på innovation, kvalitet och design. Här kan du se hela vårt utbud av innovativa tjänstebilar med mycket körglädje.',
      link: 'https://www.kia.com/se/nya-bilar/bilmodeller/',
    },
  ],
};

export const buyerNews = {
  title: 'Bra att veta för dig som är inköpare',

  image_src: 'https://www.fillmurray.com/840/450',
  link_style: 'text',
  description:
    'Vad gäller för ramavtal? Hur beräknas restvärdet? Och vilka tjänstebilsmodeller kan du välja mellan? Här hittar du information om vanliga begrepp och frågor som rör tjänstebilsaffären - så att det blir ännu enklare för dig att välja en Kia som tjänstebil.',
  articles: [
    {
      title: 'TCO',
      text: 'TCO står för Total Cost of Ownership. Det är den totala ägandekostnaden som avgör hur mycket en bil kommer att kosta i slutänden. För att räkna ut TCO ska alla kostnader, tillexempel leasingavgift, extrautrustning, service, försäkringar, skatter osv inkluderas. Du kan läsa mer om TCO under ”Vanliga frågor och svar om tjänstebilar.”',
    },
    {
      title: 'Restvärde',
      text: 'Restvärdet är det värde som bilen uppskattas ha vid leasingperiodens slut och som till stor del bestämmer hur hög leasingavgiften ska vara. I en finansiell leasing bör det faktiska restvärdet vid leasingperiodens slut läggas något lägre än det förväntade marknadsvärdet för att vara på den säkra sidan.',
    },
    {
      title: 'Ramavtal',
      text: 'För att få bästa möjliga villkor vid köp av Kia-bilar kan företag med minst 10 personbilar i vagnparken teckna ett ramavtal med Kia Sweden AB. Det finns även andra förmånliga erbjudanden för företag med mindre vagnparker. Kontakta din Kia-återförsäljare för mer information.',
    },
    {
      title: 'Vill du veta mer?',
      text: 'Är du ansvarig för ditt företags tjänstebilar och vill veta mer om Kias tjänstebilserbjudande? Då är du välkommen att kontakta din Kia-återförsäljare som hjälper dig med rådgivning.',
      link: 'https://www.kia.com/se/tjanstebil/kia-fleet-team/',
    },
    {
      title: 'Brett utbud av tjänstebilar',
      text: 'Vi vet vad som krävs av en tjänstebil och utvecklar hela tiden våra modeller så att de lever upp till våra högt ställda krav på innovation, kvalitet och design. Här kan du se hela vårt utbud av innovativa tjänstebilar med mycket körglädje.',
      link: 'https://www.kia.com/se/nya-bilar/bilmodeller/',
    },
  ],
};

export const fleetPuff = {
  title: 'Tjänstebilskalkylatorn',
  subTitle: 'Räkna på din tjänstebil',
  text: 'Ta reda på vad tjänstebilen kommer kosta. Du kan räkna ut kostnaden för företaget och för föraren. Det gör det enkelt att jämföra vad olika laddbara modeller och avtal gör för skillnad i praktiken.',
  link: 'https://www.kia.com/se/tjanstebil/kalkyl-laddhybrid/',
  linkText: 'Tjänstebilskalkylatorn',
  image:
    'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/tjanstebil.jpg',
};

export const hero2 = {
  title: 'Teknologi som tar dig framåt',
  subtitle:
    'Kia EV9 och EV6 är utvecklade för att ta dig ut på längre resor och med mer utrymme vilket ger dig balanserade körupplevelser. Den långa hjulbasen hos E-GMP-plattformen ger dig en rymlig kupé med hög komfort för alla i bilen. Den banbrytande plattformen bidrar också till inspirerande köregenskaper, en stabil och tyst upplevelse även i högre hastigheter och imponerande räckvidder.  Med sin banbrytande 800-voltsteknik kan EV9 och EV6 laddas ultrasnabbt från 10–80 % på ned till 24 minuter. Upplev en ny standard för elektrisk komfort och prestanda.',
  image:
    'https://kia-afonso.b-cdn.net/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/LaddbarRorelse.jpg?quality=80',
};

export const news2 = {
  title: 'Hundratusentals laddningsmöjligheter med Kia Charge',
  image:
    'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/contents/purchase-guide/kampanjer/ceed-vi-lever-nu/freecoding/assets/images/kia-ceed-laddkontakt.jpg',
  image_src: 'https://www.kia.com/se/aga/support/kia-charge/',
  description:
    'När du inte kan ladda hemma är Kia Charge en enkel och lättanvänd laddningstjänst längs vägarna. Allt du behöver är ett kort, eller Kia Charge-appen, för att få tillgång till hundratusentals laddstationer över hela Europa med klimatneutral el. I appen kan du enkelt planera resans laddstopp och Kia Charge är nyckeln till det bästa laddningsnätverket Ionity.',
  cta: {
    url: 'https://www.kia.com/se/aga/support/kia-charge/',
    text: 'Läs mer om Kia Charge',
  },
  link_style: 'button',
  articles: [
    {
      title: 'Kia Serviceavtal',
      text: 'När du köper en tjänstebil från Kia kan du välja Kia Serviceavtal. Det innebär att du får Kia Originalservice till en fast månadskostnad, reservdelar som är speciellt framtagna och utvalda för just din tjänstebil, samt fri assistans till närmaste serviceställe om det händer något på vägen.',
      link: 'https://www.kia.com/se/aga/originalservice/serviceavtal/',
      linkText: 'Läs mer',
      image:
        'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/Serviceavtal.jpg',
    },
    {
      title: 'Kia Originaltillbehör',
      text: 'Behöver du dragkrok, lastgaller eller takbox till din tjänstebil? Med Kia Originaltillbehör kan du komplettera din tjänstebil med tillbehör som är konstruerade, tillverkade och testade för att passa din Kia Tjänstebil perfekt.',
      link: 'https://www.kia.com/se/aga/tillbehor/?gclid=CjwKCAjw6dmSBhBkEiwA_W-EoC20t_0weX72SRN76gORj69_ssgHE5-kDanlQywk7ozL2lXP_zzLmRoCikMQAvD_BwE',
      linkText: 'Läs mer',
      image:
        'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/Tillbehor.jpg',
    },
    {
      title: 'Uppkopplade tjänster',
      text: 'Gör körupplevelsen med din tjänstebil ännu bättre med tjänster anpassade för en uppkopplad vardag. Kia Connect-appen ger dig information i realtid och assisterar dig i varje situation. Med Apple CarPlay och Android Auto kan du lyssna på din favoritpodd eller på din spellista.',
      link: 'https://www.kia.com/se/om-kia/upplev-kia/teknik/kia-connect/',
      linkText: 'Läs mer',
      image:
        'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/KIA-Connect.jpg',
    },
    {
      title: '7 års nybilsgaranti',
      text: 'Med en produktkvalitet som är utvecklad och testad under extrema förhållanden erbjuder vi på Kia ett bekymmersfritt bilägande med både förutsägbarhet och kostnadskontroll för dig som företagskund. Tack vare den långa garantin har Kia-bilar ett mycket gott andrahandsvärde. Det innebär mindre värdeminskning och därmed en låg total ägandekostnad, vilket ger dig och ditt företag resurser över till annat.',
      link: 'https://www.kia.com/se/aga/kias-servicelofte/7-ars-nybilsgaranti/',
      linkText: 'Läs mer',
      image:
        'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/7ar.jpg',
    },
    {
      title: 'Kia Sweden',
      text: 'Sedan 2017 är Kia det tredje största bilmärket i Sverige och redan 2013 lanserade vi vår första elbil. Vårt mål är 100% laddbar försäljning. Kias modellprogram präglas av design, kvalitet och säkerhet och vi är stolta över att sedan 2020 vara det mest populära bilmärket bland privatpersoner. Och vi växer stadigt på företagsmarknaden.',
      link: 'https://www.kia.com/se/elbil/100-procent-laddbart-2024/',
      linkText: 'Läs mer om Kia Sweden',
      image:
        'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/KIA-Sweden.jpg',
    },
    {
      title: 'Hållbarhetsrapport',
      text: 'Visionen för Kia Corporation är att bli en hållbar, ansvarstagande och innovativ tillverkare av mobilitetslösningar. Vi stöder principerna i FN:s Global Compact och har som målsättning att vi, tillsammans med övriga bilindustrin, ska ha en nyckelroll i övergången till en fossilfri fordonsflotta. Hållbarhetsarbetet handlar också om personal- och sociala förhållanden, att bekämpa korruption och mutor, samt att skydda utsatta barn.',
      link: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/Hallbarhetsredovisning_2025-Spread-050525 1.pdf',
      linkText: 'Ladda ner hållbarhetsrapporten',
      image:
        'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/Hallbarhet.jpg',
    },
  ],
};

export const faq = {
  title: 'Vanliga frågor och svar om tjänstebilar',
  questions: [
    {
      q: 'Hur fungerar drivmedelsersättning om jag kör en tjänstebil?',
      a: `
        Det finns två olika sätt att beräkna drivmedelsersättning för tjänstebilsförare: 
        <br>1) Huvudregeln innebär att den anställde betalar allt bränsle själv och sedan tar ut milersättning för de tjänstemil som körs. Denna är för närvarande på 9 kr för diesel och 12 kr för övriga drivmedel.
        <br><br>
        2) Komplementregeln innebär att företaget står för hela bränslekostnaden och och föraren förmånsbeskattas för privatmilen med 120% av bränslekostnaden. (vid 50% marginalskatt betalar man 60% skatt på privata mil)
        Du måste kunna visa hur mycket som körts i tjänsten genom att föra körjournal, annars betraktas bilens totala körsträcka som privat körning.`,
    },
    {
      q: 'Vilken drivmedelsersättning är att föredra om jag kör en elbil som tjänstebil?',
      a: `
        I fallet med elbil är det att föredra att använda sig av Huvudregeln med milersättning på 12 kr då denna innebär en ekonomiskt mer fördelaktig lösning i de allra flesta fall om merparten av laddningen sker hemma.
        <br /><br />
        Kompletteringsregeln fungerar ej i de fall som föraren laddar hemma, på jobbet, och längs vägen då egna utlägg och företagsbetalt bränsle inte kan kombineras.
       `,
    },
    {
      q: 'Hur beräknar jag förmånsvärdet?',
      a: `
        Om du som anställd har en tjänstebil som du använder privat, behöver du utgå ifrån att den förmånen ska förmånsbeskattas. Skatten dras på din lön och baseras på den valda bilens förmånsvärde.
        `,
    },
    {
      q: 'Räknas tjänstebil som lön?',
      a: `Om du får använda bilen privat är den att betrakta som en del av din lön, och benämns då också som förmånsbil. Förmånsvärdet läggs till på din bruttolön och du får betala skatt på totalbeloppet.`,
    },
    {
      q: 'Påverkar min lön hur mycket jag betalar för tjänstebilen?',
      a: `Generellt kan man säga att ju högre lön du har desto mer förmånligt är det att ha förmånsbil, eftersom den som även betalar statlig skatt kommer att få ett förhållandevis större skatteavdrag än den som inte gör det.`,
    },
    {
      q: 'Vad händer om jag inte fyller i körjournal?',
      a: `Det är inget lagkrav på körjournal men Skatteverket kan begära att du bevisar hur du använder din tjänstebil privat. Speciellt viktigt är det för dig som har en företagsbil där antalet privata mil är begränsade till max 10 mil, vid max 10 tillfällen per år.
        <br /><br />
        Om det blir skatterevision kan utgången bero på om du har fört körjournal och hur noggrant du har fört den. Om du inte kan redovisa det ordentligt riskerar du att få betala förmånsskatt retroaktivt, även för de mil som du har kört i tjänsten.`,
    },
    {
      q: 'Vad är TCO?',
      a: `TCO står för Total Cost of Ownership och är den den totala ägandekostnaden och som avgör hur mycket en bil kommer att kosta i slutänden, inte prislappen i bilhallen. För att räkna ut den totala summan ska du ta med alla tänkbara kostnader, som leasingavgift, extrautrustning, service, försäkringar, skatter och sociala avgifter för både bil och bränsle. Tänk på att en dyr bil som körs förhållandevis sällan blir en mycket dålig ekonomisk affär eftersom kostnaden för varje körd mil blir relativt sett högre.`,
    },
    {
      q: 'Kan jag få sänkt förmånsskatt om jag kör mycket i tjänsten?',
      a: `Ja, om du kör över 3 000 mil i tjänsten/år kan du få din bilförmån sänkt med 25%.
        <br /><br />
        Det är Skatteverket som beslutar om du ska få nedsatt förmånsvärde. Ansökan ska lämnas in varje år. Blanketten som ska användas för att ansöka om nedsatt förmånsvärde heter <a href="https://www.skatteverket.se/foretagorganisationer/sjalvservice/blanketterbroschyrer/blanketter/info/4893.4.39f16f103821c58f680006780.html">SKV 4893</a>.
        `,
    },
    {
      q: 'Måste jag som arbetsgivare bokföra en ”första förhöjd hyra”?',
      a: `Det vanligaste är att företaget betalar en första förhöjd hyra. Hur mycket som ska betalas är ofta val- eller förhandlingsbart. Fördelen med att betala mer i början är att hyran sedan blir lägre under de resterande månaderna. Bokföringsmässigt ska den första förhöjda hyran sedan fördelas över hela leasingkontraktets löptid.`,
    },
    {
      q: 'Vad är fördelarna för företaget att leasa en bil istället för att köpa den?',
      a: `Det största fördelarna är att halva momsen på leasinghyran är avdragsgill, och att hela momsen på övriga kostnader (däck, service, reparation). Leasinghyran är dessutom avdragsgill mot företagets resultat och kapital slipper bindas i bilen. De pengarna kan istället användas i företagets verksamhet.`,
    },
    {
      q: 'Tjänstebil eller förmånsbil, vad är skillnaden?',
      a: `Tjänstebil är ett samlingsbegrepp för alla bilar som erbjuds anställda i jobbet. I dagligt tal används tjänstebil lika ofta för en bil som enbart får köras i jobbet som för en bil som även får användas privat. Det är dock viktigt att känna till skillnaderna.
        <br /><br />
        En tjänstebil/servicebil är avsedd att enbart användas i tjänsten, och den privata körningen är då begränsad till max 10 mil vid högst 10 tillfällen per år. Om du kör mer än så kan du bli straffbeskattad. Skatteverket kan be dig bevisa att du bara använder bilen i jobbet. Därför är det viktigt att föra noggrann körjournal.
        <br /><br />
        En tjänstebil/förmånsbil får även användas privat, men då ska den anställde betala förmånsskatt. Hur hög skatten blir beror på bilens förmånsvärde, som Skatteverket bestämmer årligen för varje bilmodell. Tillval som dragkrok och ljudanläggning höjer förmånsvärdet. Vem som betalar bränslet – du eller din arbetsgivare – spelar också in. Betalar företaget bränsle räknas det som en löneförmån och du får betala skatt.
        `,
    },
    {
      q: 'Kan jag som är egenföretagare ha en tjänstebil utan att förmånsbeskattas?',
      a: `Om din enskilda firma äger en personbil kan du undvika ett förmånsvärde genom att endast köra den privat högst tio gånger per år och högst hundra mil per år. Kör du mer än så är det inte ringa omfattning, och då måste du betala förmånsvärde.
        <br /><br />
        Det är upp till dig som företagare att kunna visa upp för Skatteverket att du inte har använt bilen privat. Det gör du genom att föra en körjournal, där du antecknar varje körning. 
Detta är vad en körjournal bör innehålla: 
<br />
<ul>
<li>datum och mätarställning vid resans start samt varifrån resan startade</li>
<li>ärende samt vilka platser/företag/kontaktpersoner du har besökt (behövs inte vid privata resor)</li>
<li>hur många kilometer du har kört</li>
<li>datum och mätarställning vid resans slut, samt var resan avslutades.</li>
<br /><br />
Tänk på att du ska föra körjournal löpande under hela året, så tänk på att göra en anteckning i körjournalen för mätarställningen vid årets början och slut.
        `,
    },
    {
      q: 'Vad händer med min tjänstebil när jag går på föräldraledighet?',
      a: `Om du har en förmånsbil så kommer du att beskattas för den även om du är föräldraledig. Men eftersom din arbetsgivare inte betalar ut någon lön till dig under föräldraledigheten finns det ingen ersättning att göra skatteavdrag ifrån. Därför får du betala skatt på förmånen i samband med deklarationen. Du kan läsa mer om vad som gäller på skatteverket.se.`,
    },
    {
      q: 'Vad gäller när jag använder min tjänstebil utomlands?',
      a: `Om du ska köra din tjänstebil utomlands är det viktigt att du alltid förvarar registreringsbeviset i bilen. Det kan också vara bra att skriva ut en skadeanmälan och förvara i bilen om något skulle hända. Se till att prata med din arbetsgivare om vad som gäller för just dig och det företag där du är anställd.`,
    },
    {
      q: 'Vad händer om jag vill köpa min tjänstebil?',
      a: `Om du och det företag som du jobbar på kommer överens om att du ska köpa den tjänstebil som du har kört måste du betala minst ett marknadsmässigt pris, annars kommer inte Skatteverket att godkänna transaktionen.`,
    },
  ],
};
